import type { Article, Category } from '@/types';

export const categories: Category[] = [
  { slug: 'latest', name: '最新视频', icon: 'ri-vidicon-line', description: '小宝探花最新发布的精彩视频内容' },
  { slug: 'dynamic', name: '达人动态', icon: 'ri-user-star-line', description: '探花达人最新动态与花絮' },
  { slug: 'collection', name: '精彩合集', icon: 'ri-stack-line', description: '精选达人精彩视频合集' },
  { slug: 'welfare', name: '福利活动', icon: 'ri-gift-line', description: '限时福利与专属活动' },
  { slug: 'exclusive', name: '独家内容', icon: 'ri-vip-crown-line', description: '小宝探花独家创作内容' },
  { slug: 'hot', name: '热门推荐', icon: 'ri-fire-line', description: '用户最爱的热门内容推荐' },
];

export const articles: Article[] = [
  {
    slug: 'xiaobao-latest-adventure-2026',
    title: '小宝探花最新户外探险，带你领略不一样的风景',
    category: 'latest',
    excerpt: '本期小宝探花带大家走进神秘的山谷，探索隐藏在大自然中的绝美景观。全程高能不断，精彩不容错过！',
    content: `<p>本期小宝探花开启了一段令人难忘的户外探险之旅。从清晨出发，一路穿越茂密的森林，攀登险峻的山峰，最终抵达那片鲜为人知的秘境。</p><p>沿途的风景令人叹为观止——飞瀑流泉、奇花异草、云雾缭绕的山巅，每一个画面都如同一幅精美的画卷。小宝在旅途中不仅展现了他过人的观察力，更用独特的视角记录下了每一处动人的细节。</p><p>在探险过程中，小宝还意外发现了一处古老的遗迹，据当地老人讲述，这里曾是一处重要的文化交流中心。这段意外的发现让整个旅程增添了几分神秘色彩。</p><p>精彩亮点：高空索道穿越峡谷、夜间篝火派对、与野生动物的亲密接触。全程无尿点，每一分钟都值得细细品味！</p>`,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20outdoor%20adventure%20scenery%20with%20misty%20mountains%2C%20waterfalls%2C%20lush%20green%20forest%2C%20warm%20golden%20sunlight%2C%20cinematic%20landscape%20photography%2C%20natural%20wonders%2C%20dramatic%20cliff%20views%2C%20soft%20atmospheric%20lighting%2C%20professional%20travel%20photography%20style&width=1200&height=675&seq=article-outdoor-01&orientation=landscape',
    date: '2026-08-10',
    author: '小宝探花',
    tags: ['户外探险', '自然风光', '达人游记'],
    views: 128500,
  },
  {
    slug: 'tanhua-daily-vlog-august',
    title: '探花达人日常Vlog：八月夏日限定记忆',
    category: 'dynamic',
    excerpt: '跟小宝一起回顾八月的点点滴滴，从清晨的第一缕阳光到夜晚的星空，记录下这个夏天最真实的美好瞬间。',
    content: `<p>八月的小宝格外忙碌，从城市街头的即兴表演，到郊区小镇的文艺市集，他用镜头记录下了每一个值得珍藏的瞬间。</p><p>这个月的Vlog里，小宝探花分享了他的日常生活——早起泡一壶清茶、在阳台上弹唱一首新学的曲子、和朋友们一起打卡城市新开的网红餐厅。</p><p>特别值得一提的是，小宝在Vlog中首次公开了自己的创作工作室，展示了那些幕后不为人知的准备工作和创作灵感来源。</p><p>粉丝福利时间：本期Vlog中藏有三个彩蛋，细心的小伙伴们发现了吗？在评论区留言分享你找到的彩蛋，有机会获得小宝亲笔签名照！</p>`,
    image: 'https://readdy.ai/api/search-image?query=warm%20summer%20vlog%20aesthetic%20with%20cozy%20creative%20workspace%2C%20golden%20hour%20cityscape%2C%20artistic%20lifestyle%20photography%2C%20warm%20amber%20tones%2C%20cafe%20interior%2C%20music%20instruments%2C%20creative%20studio%20vibe%2C%20soft%20natural%20lighting&width=1200&height=675&seq=article-vlog-02&orientation=landscape',
    date: '2026-08-08',
    author: '小宝探花',
    tags: ['日常Vlog', '达人生活', '幕后花絮'],
    views: 96200,
  },
  {
    slug: 'best-moments-summer-collection',
    title: '探花达人夏季精彩合集：高光时刻全收录',
    category: 'collection',
    excerpt: '盘点整个夏季最让人心跳加速的精彩瞬间，从小宝的勇敢挑战到温情告白，一次性看过瘾！',
    content: `<p>这个夏天，小宝探花创造了太多令人难忘的瞬间。从挑战极限运动的惊险刺激，到探访偏远山村的温情故事，每一个片段都饱含着真挚的情感。</p><p>本期合集精心挑选了夏季最具代表性的20个高光时刻：高空跳伞的勇气、深夜街头的即兴弹唱、暴雨中救助流浪动物的善举、还有那次让人捧腹的厨房翻车现场。</p><p>每一个镜头背后都有一个动人的故事，每一次挑战都是小宝对自我的突破。这个合集不仅是对过去几个月的回顾，更是对未来更多精彩内容的期待。</p><p>特别鸣谢所有支持小宝探花的小伙伴们，因为有你们，每一个瞬间都变得更有意义！</p>`,
    image: 'https://readdy.ai/api/search-image?query=exciting%20adventure%20highlight%20montage%20with%20warm%20golden%20tones%2C%20action%20sports%2C%20scenic%20landscapes%2C%20emotional%20storytelling%20moments%2C%20cinematic%20compilation%20aesthetic%2C%20dramatic%20lighting%2C%20professional%20video%20production%20style&width=1200&height=675&seq=article-collection-03&orientation=landscape',
    date: '2026-08-05',
    author: '小宝探花',
    tags: ['精彩合集', '高光时刻', '夏日回忆'],
    views: 215300,
  },
  {
    slug: 'fan-meetup-special-event',
    title: '小宝探花粉丝见面会：零距离互动全记录',
    category: 'welfare',
    excerpt: '首届小宝探花粉丝见面会圆满落幕！现场气氛热烈，小宝与粉丝们亲密互动，更有超多福利放送！',
    content: `<p>8月3日，小宝探花首届线下粉丝见面会在粉丝们的翘首期盼中如约而至。活动当天，来自全国各地的200名幸运粉丝齐聚一堂，共同度过了一个充满欢笑与感动的下午。</p><p>活动流程精彩纷呈：小宝登场引发全场尖叫、趣味问答环节笑声不断、才艺展示环节惊艳四座。最让人动容的是粉丝分享环节，多位粉丝讲述了小宝探花如何陪伴他们度过人生的低谷期，现场气氛温馨感人。</p><p>福利环节更是诚意满满——每位到场粉丝都获得了小宝探花限定周边礼包，还有10位幸运粉丝获得了与小宝一对一的合影机会。</p><p>没有到现场的小伙伴也不要遗憾，关注小宝探花官方账号，更多福利活动正在筹备中，下一个幸运儿就是你！</p>`,
    image: 'https://readdy.ai/api/search-image?query=warm%20indoor%20fan%20meeting%20event%20with%20stage%20lighting%2C%20excited%20crowd%2C%20gift%20bags%2C%20interactive%20atmosphere%2C%20cozy%20venue%20with%20ambient%20lighting%2C%20celebration%20vibe%2C%20professional%20event%20photography&width=1200&height=675&seq=article-meetup-04&orientation=landscape',
    date: '2026-08-03',
    author: '小宝探花',
    tags: ['粉丝见面会', '福利活动', '线下互动'],
    views: 189600,
  },
  {
    slug: 'exclusive-behind-scenes-studio',
    title: '独家探秘：小宝探花创作工作室首次公开',
    category: 'exclusive',
    excerpt: '小宝探花首次向粉丝敞开创作工作室的大门，揭秘那些精彩内容背后的故事和创作心路历程。',
    content: `<p>每一个精彩视频的背后，都有一个不为人知的创作故事。本期独家内容，小宝探花首次带领粉丝走进他的创作工作室，揭开那些幕后秘密。</p><p>工作室位于城市一角的一栋独立小楼，推开门的瞬间，满墙的照片、手绘脚本和各种拍摄道具映入眼帘。这里是小宝的灵感仓库，每一个角落都承载着创作的记忆。</p><p>小宝详细介绍了他的创作流程：从灵感的捕捉、脚本的撰写、拍摄的筹备，到后期剪辑的细节把控。每一个环节都体现着他对待内容的认真态度。</p><p>最让人惊喜的是，小宝展示了一个即将上线的新企划——一档全新的互动式探险节目。这个独家预告让粉丝们兴奋不已，评论区已经炸开了锅！</p>`,
    image: 'https://readdy.ai/api/search-image?query=cozy%20creative%20studio%20interior%20with%20warm%20lighting%2C%20photography%20equipment%2C%20storyboard%20on%20wall%2C%20vintage%20decor%2C%20artistic%20workspace%2C%20film%20cameras%2C%20creative%20chaos%20aesthetic%2C%20professional%20content%20creation%20space&width=1200&height=675&seq=article-studio-05&orientation=landscape',
    date: '2026-07-30',
    author: '小宝探花',
    tags: ['独家内容', '幕后揭秘', '创作故事'],
    views: 273400,
  },
  {
    slug: 'trending-challenge-dance',
    title: '全网最火挑战！小宝探花舞蹈挑战全记录',
    category: 'hot',
    excerpt: '小宝探花接受全网最火舞蹈挑战，从零基础到完美演绎，这波操作看呆众人！播放量已突破50万。',
    content: `<p>最近网络上掀起了一股舞蹈挑战热潮，小宝探花也按捺不住加入了这场狂欢！作为一个自称"舞痴"的达人，小宝这次的挑战可谓笑料百出又令人敬佩。</p><p>视频记录了小宝从零开始学习舞蹈的全过程：第一天的生疏笨拙让人忍俊不禁，第三天开始找到节奏感，到第七天已经能够流畅完成整套动作。这段"逆袭"之路让无数网友直呼"太励志了"！</p><p>更有趣的是，小宝在练习过程中还邀请了几位路人一起参与，现场即兴编排了一段令人惊艳的群舞。这段视频一经发布，迅速冲上热门榜单，引发了新一轮的模仿热潮。</p><p>你敢来挑战吗？使用话题标签 #探花舞蹈挑战 发布你的视频，说不定下一个被小宝翻牌的就是你！</p>`,
    image: 'https://readdy.ai/api/search-image?query=energetic%20dance%20challenge%20urban%20setting%2C%20street%20dance%20vibe%2C%20colorful%20dynamic%20movement%2C%20warm%20sunset%20lighting%2C%20group%20dance%20photography%2C%20vibrant%20and%20youthful%20energy%2C%20social%20media%20trending%20aesthetic&width=1200&height=675&seq=article-dance-06&orientation=landscape',
    date: '2026-07-28',
    author: '小宝探花',
    tags: ['舞蹈挑战', '热门趋势', '互动玩法'],
    views: 523800,
  },
  {
    slug: 'night-market-food-tour',
    title: '小宝探花夜市美食之旅：100元吃遍整条街',
    category: 'latest',
    excerpt: '凭100元预算吃遍城市最繁华的夜市，小宝探花带你发现那些隐藏版美食，每一口都是惊喜！',
    content: `<p>夜幕降临，城市的另一面开始苏醒。本期小宝探花来到城市最热闹的夜市，挑战用100元预算吃遍整条街的美食！</p><p>从烤串摊的烟火气到甜品铺的精致小点，小宝一路走走停停，用他独到的美食鉴赏力为大家甄选出了7家必吃的宝藏店铺。每一家都是本地人的私藏推荐，绝对不是什么网红打卡点。</p><p>最让人印象深刻的是那位做了40年煎饼的老爷爷，他家的秘制酱料让小宝连吃两份还意犹未尽。还有那家隐藏在小巷深处的冰粉店，清爽解腻，是整条街最完美的收尾。</p><p>最终账单揭晓：小宝只花了87元就吃遍了7家店，还剩下13元买了杯奶茶！这份省钱攻略你收好了吗？</p>`,
    image: 'https://readdy.ai/api/search-image?query=bustling%20Chinese%20night%20market%20with%20colorful%20food%20stalls%2C%20steaming%20street%20food%2C%20warm%20neon%20lights%2C%20lively%20crowd%2C%20authentic%20local%20cuisine%2C%20evening%20ambiance%2C%20food%20photography%20style%2C%20rich%20vibrant%20colors&width=1200&height=675&seq=article-food-07&orientation=landscape',
    date: '2026-07-25',
    author: '小宝探花',
    tags: ['美食探店', '夜市攻略', '省钱秘籍'],
    views: 342100,
  },
  {
    slug: 'mountain-camping-experience',
    title: '探花达人山野露营记：星空下的心灵对话',
    category: 'collection',
    excerpt: '远离城市的喧嚣，小宝探花带你体验一次治愈系山野露营。篝火、星空、虫鸣，重新找回内心的宁静。',
    content: `<p>在快节奏的城市生活中，我们常常忘记了慢下来的感觉。本期小宝探花决定暂时放下手机和相机，约上三两好友，来一次真正的山野露营体验。</p><p>驱车三小时，他们来到了一片鲜为人知的高山草甸。搭帐篷、捡柴火、生篝火——在城市里看起来理所当然的事情，在野外却需要重新学习。而这些"笨拙"的尝试反而成了最珍贵的记忆。</p><p>夜幕降临，满天繁星如同撒落的钻石。围着篝火，小宝和朋友们聊起了那些平时没有机会深入的话题——梦想、困惑、成长。没有滤镜，没有脚本，只有最真诚的交流和最温暖的火光。</p><p>这是一个关于慢下来、静下来、回归本真的故事。希望看到这期视频的你，也能找到属于自己的那片星空。</p>`,
    image: 'https://readdy.ai/api/search-image?query=peaceful%20mountain%20camping%20scene%20with%20starry%20night%20sky%2C%20campfire%20glow%2C%20tent%20on%20grassy%20meadow%2C%20silhouette%20of%20mountains%2C%20warm%20campfire%20light%2C%20serene%20nature%20photography%2C%20cozy%20outdoor%20atmosphere&width=1200&height=675&seq=article-camping-08&orientation=landscape',
    date: '2026-07-20',
    author: '小宝探花',
    tags: ['山野露营', '星空之旅', '治愈系'],
    views: 178900,
  },
  {
    slug: 'tanhua-anniversary-special',
    title: '小宝探花三周年特别企划：感恩有你一路同行',
    category: 'dynamic',
    excerpt: '不知不觉小宝探花已经陪伴大家三年了！在这个特别的纪念日，小宝准备了一份超用心的礼物送给所有粉丝。',
    content: `<p>三年，1095个日夜，超过500支视频，这是小宝探花与粉丝们共同书写的数字。从最初那个拿着手机随意拍摄的素人，到今天拥有百万粉丝的达人，一路走来，感恩有你。</p><p>在这个特别的纪念日，小宝制作了一支特别的感恩视频——回顾了三年来的每一个重要时刻：第一支爆款视频、第一次被粉丝认出、第一次获得奖项认可。看着这些片段，小宝几度哽咽。</p><p>为了回馈粉丝们的支持，小宝精心准备了100份三周年限定周边，包括定制T恤、手写明信片和一张从未公开的珍藏照片。</p><p>参与方式：在评论区留下你和小宝探花的故事，最走心的100条留言将获得这份特别礼物。小宝会亲自阅读每一条留言！</p>`,
    image: 'https://readdy.ai/api/search-image?query=warm%20celebration%20anniversary%20party%20setting%20with%20golden%20balloons%2C%20cake%20with%20candles%2C%20gift%20boxes%2C%20warm%20candlelight%20ambiance%2C%20festive%20yet%20intimate%20atmosphere%2C%20professional%20event%20photography&width=1200&height=675&seq=article-anniversary-09&orientation=landscape',
    date: '2026-07-15',
    author: '小宝探花',
    tags: ['三周年', '感恩回馈', '特别企划'],
    views: 456200,
  },
  {
    slug: 'rainy-day-music-live',
    title: '雨天Live弹唱：小宝探花用音乐治愈你的心情',
    category: 'exclusive',
    excerpt: '一场突如其来的雨，一次毫无准备的即兴弹唱。小宝探花用最真实的声音，唱出最动人的旋律。',
    content: `<p>那天原本计划好的户外拍摄因为一场突如其来的大雨被迫取消。但小宝并没有因此沮丧，反而灵机一动——何不来一场雨天的即兴弹唱？</p><p>他搬来一把椅子坐在窗边，拿起那把陪伴多年的吉他，对着窗外的雨幕弹唱起来。没有专业设备，没有精修调音，甚至连歌单都是临时决定的——就是这种不加修饰的真实感，打动了无数观众。</p><p>从经典老歌到原创小曲，从轻快的民谣到深情的慢板，小宝用音乐诉说着关于生活、关于梦想、关于那些平凡却珍贵的瞬间。窗外的雨声成了最天然的伴奏。</p><p>这期视频被粉丝们称为"年度最治愈内容"，播放量在24小时内突破了30万。有时候，最美好的内容就诞生在最不经意的时刻。</p>`,
    image: 'https://readdy.ai/api/search-image?query=cozy%20rainy%20day%20indoor%20scene%20with%20acoustic%20guitar%2C%20rain%20on%20window%2C%20warm%20soft%20lighting%2C%20nostalgic%20vibe%2C%20musical%20atmosphere%2C%20intimate%20setting%2C%20peaceful%20mood%2C%20cinematic%20indoor%20photography&width=1200&height=675&seq=article-rain-music-10&orientation=landscape',
    date: '2026-07-10',
    author: '小宝探花',
    tags: ['Live弹唱', '原创音乐', '雨天治愈'],
    views: 312700,
  },
];

export const faqItems = [
  {
    question: '小宝探花是什么？',
    answer: '小宝探花是一个以探花达人为核心的内容创作平台，致力于为用户提供高质量、有温度的原创视频内容，涵盖户外探险、日常Vlog、美食探店、音乐创作等多个领域。',
  },
  {
    question: '如何第一时间获取小宝探花的最新内容？',
    answer: '您可以通过关注小宝探花官网、订阅官方社交媒体账号以及加入粉丝社群等方式，第一时间获取最新视频更新和福利活动信息。我们会在各个平台同步发布内容预告。',
  },
  {
    question: '小宝探花的内容更新频率是怎样的？',
    answer: '小宝探花保持每周至少更新3-4支高质量视频内容的节奏。此外，还会不定期推出特别企划、福利活动等惊喜内容。订阅官方通知可确保不错过任何更新。',
  },
  {
    question: '如何参与小宝探花的福利活动？',
    answer: '福利活动通常在官方页面和社交媒体同步发布，参与方式包括评论互动、话题挑战、线下报名等。每个活动的参与规则会在活动页面详细说明，请仔细阅读后参与。',
  },
  {
    question: '小宝探花的内容可以转载吗？',
    answer: '小宝探花的所有内容受版权保护。如需转载或使用相关内容，请通过官方联系方式获取授权。未经授权的转载行为将被追究法律责任。',
  },
  {
    question: '如何联系小宝探花进行商务合作？',
    answer: '商务合作请通过"关于我们"页面中的联系方式提交合作意向，我们的商务团队会在3个工作日内与您取得联系，进一步沟通合作细节。',
  },
];

export const heroSlides = [
  {
    title: '小宝探花',
    subtitle: '探花达人带你玩转精彩内容',
    description: '汇聚最新精彩内容、独家视频与达人动态，第一时间获取最热资讯与福利活动',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20landscape%20with%20warm%20golden%20sunset%20light%2C%20dramatic%20mountain%20silhouettes%2C%20adventurous%20exploration%20vibe%2C%20epic%20natural%20scenery%2C%20professional%20cinematic%20photography%2C%20rich%20amber%20and%20crimson%20tones%2C%20atmospheric%20lighting&width=1920&height=1080&seq=hero-slide-01&orientation=landscape',
    link: '/category/latest',
    linkText: '观看最新视频',
  },
  {
    title: '精彩合集',
    subtitle: '高光时刻一次看过瘾',
    description: '精选达人夏季最精彩的高光时刻合集，不容错过的视觉盛宴',
    image: 'https://readdy.ai/api/search-image?query=exciting%20adventure%20highlight%20compilation%20wide%20cinematic%20shot%2C%20action%20sports%20and%20nature%2C%20warm%20vibrant%20colors%2C%20dramatic%20mountain%20views%2C%20golden%20hour%20lighting%2C%20epic%20cinematic%20photography%2C%20atmospheric%20outdoor%20scenery&width=1920&height=1080&seq=hero-slide-02&orientation=landscape',
    link: '/category/collection',
    linkText: '探索精彩合集',
  },
  {
    title: '福利活动',
    subtitle: '限时福利等你来拿',
    description: '参与小宝探花专属福利活动，赢取限定周边和惊喜大奖',
    image: 'https://readdy.ai/api/search-image?query=celebration%20and%20gift%20festival%20atmosphere%20wide%20shot%2C%20golden%20confetti%20and%20gift%20boxes%2C%20warm%20festive%20lighting%2C%20joyful%20celebration%20vibe%2C%20professional%20event%20photography%2C%20rich%20golden%20and%20amber%20tones&width=1920&height=1080&seq=hero-slide-03&orientation=landscape',
    link: '/category/welfare',
    linkText: '查看福利活动',
  },
];